import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";
import { PriceTypeField, priceTypeFieldCopy } from "@/components/ListingFields/PriceTypeField";

const LISTING_TYPE = "service" as const;

export interface ServicePriceTypeEditorProps {
  /** Called with the new choice ("free" or "paid"). */
  onChange: (value: string) => void;
  /** Whether the account can take payment; drives the delisting warning. */
  stripeConnected: boolean;
  value: "free" | "paid";
}

export function ServicePriceTypeEditor({ onChange, stripeConnected, value }: ServicePriceTypeEditorProps) {
  return (
    <EditorSection {...priceTypeFieldCopy(LISTING_TYPE)}>
      <PriceTypeField
        listingType={LISTING_TYPE}
        onChange={onChange}
        // The section pane is narrower than the wizard's centred stage.
        size="3xl"
        stripeConnected={stripeConnected}
        value={value}
      />
    </EditorSection>
  );
}
